// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_base-pagination_wrapper_2indd"};